import React from'react';

class InputZscore extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text: '',
        }
        this.handleChange = this.handleChange.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.isNumberKey = this.isNumberKey.bind(this);
    }

    // Update target z-score when user types input
    handleChange(e) {
        this.props.update(e.target.value);
    }

    // Disable Submitting Form on 'Enter'
    submitHandler(e) {
        e.preventDefault();
    }

    isNumberKey(event) {
        let charCode = (event.which) ? event.which : event.keyCode;
        let str = event.target.value + String.fromCharCode(charCode);

        // Ignore characters that are not '.' and a number
        if (charCode !== 45 && charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
            event.preventDefault()
            return false;
        }

        if (str.match(/^-?[0-9]*[.][0-9]+$/)) {
            // console.log("full match");
        } else if (str.match(/^-?[0-9]*[.]$/)) {
            // console.log("dot match");
        } else if (str.match(/^-?[0-9]*$/)) {
            // console.log("integer match");
        }  else if (str.match(/^-?$/)) {
            // console.log("sign match");
        } else {
            // console.log("no match");
            event.preventDefault()
            return false;
        }

        return true;
    }

    // Build Input Field
    render() {
        const zscr = (this.props.zscore.toString() === 'NaN') ? '' : this.props.zscore;
        // Build Input Form
        return (
            <div>
                <form onSubmit={this.submitHandler}
                    autoComplete="off"
                >
                    <label htmlFor="zscore">Z Score</label>
                    <input type="float"
                        id="zscore"
                        name="zscore"
                        placeholder='Enter z-score'
                        value={zscr}
                        onKeyPress={this.isNumberKey}
                        onChange={this.handleChange} />
                </form>
            </div>
        );
    }
}

export default InputZscore;